// extracted by mini-css-extract-plugin
module.exports = {"root":"Custom_root__37zmL","menuButton":"Custom_menuButton__1u2ax"};